import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, SurfaceColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      position: 'relative',

      [muiTheme.breakpoints.up('md')]: {
        backgroundColor: SurfaceColors.light,
        borderRadius: '4px',
        paddingTop: muiTheme.spacing(6.5),
      },
    },
    breadcrumbs: {
      '&:not(:empty)': {
        marginBottom: muiTheme.spacing(3),
      },
    },
    categoryTabs: {
      '&.MuiTabs-root': {
        borderTopColor: hexToRGBA(TextColors.dark, TextOpacities.light4),
        color: TextColors.dark,
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        margin: 0,
        padding: muiTheme.spacing(0, 7.5),
        width: '100%',

        [muiTheme.breakpoints.down('sm')]: {
          // backgroundColor: SurfaceColors.light,
          borderTop: 'none',
          flex: 'auto',
          padding: 0,
          margin: '0 -32px',
        },

        '& .MuiTabs-indicator': {
          backgroundColor: SecondaryColors.dark,
        },

        '& .MuiTabs-scrollButtons': {
          width: 32,
        },

        '& .MuiTabs-flexContainer': {
          justifyContent: 'space-between',
        },
      },
    },
    categoryTab: {
      '&.MuiButtonBase-root': {
        borderRadius: '4px',
        height: muiTheme.spacing(6),
        margin: muiTheme.spacing(3.5, 0),
        padding: muiTheme.spacing(0, 4),

        [muiTheme.breakpoints.down('sm')]: {
          backgroundColor: SurfaceColors.light,
          ...muiTheme.typography.body2,
          fontWeight: '500',
          flex: 'none',
          height: muiTheme.spacing(12.5),
          margin: muiTheme.spacing(0, 1, 0, 0),
          padding: muiTheme.spacing(1),
          width: muiTheme.spacing(12.5),
          maxWidth: muiTheme.spacing(12.5),
          lineHeight: 1.25,
        },

        '& .MuiTab-wrapper': {
          flexDirection: 'row',
          justifyContent: 'flex-start',

          [muiTheme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            justifyContent: 'center',
          },
        },

        // '&.MuiTab-labelIcon .MuiTab-wrapper > *:first-child': {
        //   marginBottom: 0,
        // },
      },
    },
    categoryIcon: {
      display: 'flex',
      marginRight: muiTheme.spacing(2),
      marginBottom: 0,
      width: muiTheme.spacing(4),

      [muiTheme.breakpoints.down('sm')]: {
        marginBottom: muiTheme.spacing(1),
        marginRight: 0,
      },

      '& picture': {
        width: '100%',

        [muiTheme.breakpoints.down('sm')]: {
          width: muiTheme.spacing(4),
        },
      },
    },
    disclaimerContainer: {
      '&': {
        [muiTheme.breakpoints.up('md')]: {
          marginBottom: muiTheme.spacing(6.5),
        },
      },
    },
    disclaimerInfo: {
      color: hexToRGBA(TextColors.dark, TextOpacities.light2),
    },
    disclaimerTrigger: {
      ...muiTheme.typography.overline,
      color: SecondaryColors.dark,
      background: 'transparent',
      border: 'none',
      padding: muiTheme.spacing(0.5, 0),
      marginBottom: muiTheme.spacing(1),

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: muiTheme.spacing(2),
      },

      '&:hover': {
        cursor: 'pointer',
      },
    },
    introHeader: {
      backgroundColor: SurfaceColors.light,
      padding: muiTheme.spacing(4),
      borderRadius: '4px',

      [muiTheme.breakpoints.up('md')]: {
        padding: muiTheme.spacing(0, 12.5),
      },
    },
    introDescription: {
      marginBottom: muiTheme.spacing(1.5),

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: muiTheme.spacing(3),
      },
    },
    introHeading: {
      '&.MuiTypography-root': {
        color: TextColors.dark,
        marginBottom: muiTheme.spacing(1.5),
        marginTop: 0,

        [muiTheme.breakpoints.up('md')]: {
          marginBottom: muiTheme.spacing(3),
        },
      },
    },
    quickLinks: {
      '$root &': {
        paddingRight: '100px',

        '& h1, h2, h3, h4, h5, h6': {
          ...muiTheme.typography.overline,
          margin: muiTheme.spacing(0, 0, 3, 0),
        },

        [muiTheme.breakpoints.up('md')]: {
          '& h1, h2, h3, h4, h5, h6': {
            margin: muiTheme.spacing(1.125, 0, 3, 0),
          },
        },

        '& a': {
          ...muiTheme.typography.h5,
          fontSize: '16px !important',
        },

        '& p': {
          marginTop: 0,
          marginBottom: muiTheme.spacing(1),
        },

        [muiTheme.breakpoints.down('sm')]: {
          padding: muiTheme.spacing(3.5, 3, 3.5, 3),
          textAlign: 'center',
        },
      },
    },
    relatedLinks: {
      marginTop: 0,

      '& a': {
        whiteSpace: 'normal !important',
        display: 'inline-block',
      },
    },
  }),
  { name: 'GenSDLIntroContent' },
);

export default useStyles;
